module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.$route.name === "home" && _vm.mosaic && _vm.item.acf.show_in_front_page_mosaic) || _vm.$route.name === "search" || _vm.$route.name === "collection") ? _c('div', {
    staticClass: "item",
    attrs: {
      "id": "item-" + _vm.item.id
    }
  }, [_c('v-waypoint', {
    on: {
      "waypoint-in": _vm.inHandler
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.imageClass
  }, [(_vm.item.acf.mosaic_image.mime_type === "image/gif") ? [(_vm.item.acf.Image_display !== "None") ? _c('img', {
    attrs: {
      "src": _vm.item.acf.mosaic_image.url
    },
    on: {
      "click": _vm.openSingle
    }
  }) : _c('img', {
    staticClass: "no-link",
    attrs: {
      "src": _vm.item.acf.mosaic_image.url
    }
  })] : [(_vm.item.acf.link_image_to_collection && _vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('a', {
    attrs: {
      "href": _vm.item.acf.image_link
    }
  }, [_c('img', {
    staticClass: "ksksks",
    attrs: {
      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
    }
  })]) : (_vm.item.acf.Image_display !== "None" && _vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('img', {
    attrs: {
      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
    },
    on: {
      "click": _vm.openSingle
    }
  }) : (_vm.item.acf.mosaic_image.sizes && _vm.item.acf.mosaic_image.sizes["pwr-medium"]) ? _c('img', {
    staticClass: "no-link",
    attrs: {
      "src": _vm.item.acf.mosaic_image.sizes["pwr-medium"]
    }
  }) : _vm._e()], _vm._v(" "), _c('figcaption', {
    staticClass: "shown"
  }, [_c('cap', {
    attrs: {
      "content": _vm.item.acf.caption,
      "id": _vm.item.id,
      "links": _vm.item.acf.links
    }
  })], 1)], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e2e5b9d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item.vue
// module id = 471
// module chunks = 2